import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "7a331aed-6ceb-43fa-8181-349f7b185999", // AAD 应用注册的 clientId
    authority: "https://login.chinacloudapi.cn/ae487bcc-5e13-43e5-97f9-7b3a907e04f5", // 你的租户
    redirectUri: "https://jxs.0l.gs", // 登录成功后回调地址
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "offline_access", "User.Read"],
};

export const msalInstance = new PublicClientApplication(msalConfig);

export async function initMsal() {
  await msalInstance.initialize();
}